import * as Styles from './styles';

export const ButtonActionsRoot = ({children, position, ...rest}) => {
    return (
        <Styles.TableActions {...rest} position={position}>
            {children}
        </Styles.TableActions>    
    )
}